<div class="rb" [class.active]="value">
    <div class="rb-input">
        <div class="rb-mark"></div>
    </div>
    <div class="rb-label" [innerHTML]="label"></div>
</div>
